import React, { useEffect, useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

export interface DraggedSingleData {
	img: string;
	text: string;
}

var selectedIndx = -1;
var dataBeingDraggedNotInState: DraggedSingleData = null;
var dataBeingDraggedNotInState508: DraggedSingleData = null;
var tempSelectedItem = -1;
const DragToolsUI = (props: UIProperties<DragToolsUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [draggedData, setDraggedData] = useState(props.parameters.toolsToChooseFrom.map((t: any, i: number) => {
		return {
			img: null,
			text: null
		}
	}));
	const mouseMoveMethod = (event: MouseEvent) => { 
		(window as any)['currentDraggedItemPositionData'] = {
			top: event.clientY,
			left: event.clientX,
			img: (window as any)['currentDraggedItemPositionData'].img
		}
	};
	const spawnRowBttn = (foregroundImg: string, text: string, indx: number, isDraggable: boolean) => {
		var width = 0;
		var top = 0;
		var height=0;
		if(props.parameters.toolsToChooseFrom.length === 5) {
			width = 174;
			height = 115.2;
			top=10;
			if(!isDraggable) {
				width = 170;
				top=37;
			}
		} else {
			width = 217.5;
			height = 144;
			top=0;
			if(!isDraggable) {
				top=27;
				width = 205;
			}
		}

		var stepBg = props.parameters.toolsToChooseFrom.length === 5 ? './assets/images/Toolbag/step-cric-bg.png' : './assets/images/Toolbag/step-bg.png';
		const get508Text = () => {
			if(text.toLocaleLowerCase().trim() === 'cric') {
				return text;
			}
			return text.split('').join(' ');
		}

		const onPlaceItem = () => {
			var isCorrect = false;
					if(selectedIndx !== -1) {
						if(props.parameters.isTestScenario || props.parameters.toolsToChooseFrom.length !== 5) { //only for cric tools
							isCorrect = true; //technically not always the case in test scenario, but we bypass jit feedback / corrections
						} if(props.parameters.correctToolOrder) {
							isCorrect = props.parameters.correctToolOrder[selectedIndx].img === dataBeingDraggedNotInState.img;
						} else {
							isCorrect = props.parameters.toolsToChooseFrom[selectedIndx].img === dataBeingDraggedNotInState.img;
						}
					}

					if(props.parameters.toolsToChooseFrom.length === 5) {
						if (isCorrect && selectedIndx !== -1 && dataBeingDraggedNotInState) {
							draggedData[selectedIndx].img = dataBeingDraggedNotInState.img;
							draggedData[selectedIndx].text = dataBeingDraggedNotInState.text;
							selectedIndx = -1;
							setDraggedData(draggedData);
						} else if(!isCorrect && selectedIndx !== -1) {
							if(props.parameters.onIncorrectToolPicked) {
								props.parameters.onIncorrectToolPicked();
							}
						}
					} else {
						if (selectedIndx !== -1 && dataBeingDraggedNotInState) {
							draggedData[selectedIndx].img = dataBeingDraggedNotInState.img;
							draggedData[selectedIndx].text = dataBeingDraggedNotInState.text;
							selectedIndx = -1;
							setDraggedData(draggedData);
						}
					}

					
					(window as any)['currentDraggedItemPositionData'] = {
						top: 0,
						left: 0,
						img: null
					}
					dataBeingDraggedNotInState = {
						img: null,
						text: null
					};
					
					setForceUpdate(!forceUpdate);
					
					window.removeEventListener('pointermove', mouseMoveMethod);
					window.removeEventListener('mousemove', mouseMoveMethod);
		}

		return (
			<CustomDragToolsButton
				ariaLbl={isDraggable ? get508Text() : 'Step ' + (indx + 1)}
				idleImg={isDraggable ? '' : stepBg}
				toolNumber = {props.parameters.toolsToChooseFrom.length}
				foregroundImg={isDraggable ? foregroundImg : draggedData[indx].img}
				showYellowThingyOnTheSide={false}
				showReset={!isDraggable}
				isDisabled={draggedData.filter(d => d.img === foregroundImg).length > 0}
				width= {width +'px'}
				top= {top +'px'}
				height={isDraggable ? height + 'px' : '170px'}
				text={isDraggable ? '' : 'Step ' + (indx + 1)}
				borderStyle={dataBeingDraggedNotInState508 && dataBeingDraggedNotInState508.img === foregroundImg ? "5px solid green" : ""}
				position={{
					type: 'absolute',
					top: '0px',
					left: (width * indx) + 'px'
				}}
				onMouseOver={() => {
					if (isDraggable) {
					} else {
						selectedIndx = indx;
						console.log('selected index ' + indx)
					}
				}}
				onMouseOut={() => {
					if (isDraggable) {

					} else {
						selectedIndx = -1;
						console.log('selected index ' + indx)
					}
				}}
				onDragStart={() => {
					if(dataBeingDraggedNotInState508) {
						return;
					}
					selectedIndx = -1;
					if (isDraggable) {
						dataBeingDraggedNotInState = {
							img: foregroundImg,
							text: text
						};
						(window as any)['currentDraggedItemPositionData'] = {
							top: -1000,
							left: -1000,
							img: dataBeingDraggedNotInState.img
						}
						console.log('drag started')
						window.addEventListener('pointermove', mouseMoveMethod);
						window.addEventListener('mousemove', mouseMoveMethod);
					} else {
					}

				}}
				onReset={() => {
					draggedData[indx].img = null;
					draggedData[indx].text = null;
					setDraggedData(draggedData);
					setForceUpdate(!forceUpdate);
				}}
				onDragEnd={() => {
					if(dataBeingDraggedNotInState508) {
						return;
					}
					console.log('drag ended')
					onPlaceItem();
				}} onKeyUp={(evt: any) => {
					if(evt && evt.key === 'Enter') {
						if (isDraggable) {
							tempSelectedItem = indx;
							dataBeingDraggedNotInState508 = {
								img: foregroundImg,
								text: text
							};
							setForceUpdate(!forceUpdate);
						} else if(dataBeingDraggedNotInState508) {
							selectedIndx = indx;
							dataBeingDraggedNotInState = dataBeingDraggedNotInState508;
							tempSelectedItem = -1;
							onPlaceItem();
	
							dataBeingDraggedNotInState508 = null;
							setForceUpdate(!forceUpdate);
						}
					}
				}}/>
		)
	}
	const isDoneDisabled = () => {
		return draggedData.filter(dd => dd.img).length !== props.parameters.toolsToChooseFrom.length
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'absolute',
				top: '0',
				left: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'all'
			}} className='modal-bg'>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '1000px'
				}}>
					<img style={{
						width: '100%'
					}} src="./assets/images/Toolbag/bg.png" />
					<div style={{
						position: 'absolute',
						top: '43px',
						left: '50%',
						width: '100%',
						transform: 'translate(-50%, 0)'
					}}>
						<p tabIndex={0} id="toolbag-header" className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '40pt',
							fontWeight: 'normal'
						}}>{props.parameters.toolsToChooseFrom.length === 5 ? 'Cric Tools Arrangement' : 'Tool Bag Arrangement'}</p>
					</div>
					<div style={{
						position: 'absolute',
						top: '135px',
						left: '58px',
						width: '886px',
						height: '547px'
					}}>
						<div style={{
							position: 'absolute',
							top: '10px',
							left: '50%',
							width: '100%',
							transform: 'translate(-50%, 0)'
						}}>
							<p tabIndex={0} className='title-font' style={{
								textAlign: 'center',
								margin: '0',
								fontSize: '14pt',
								fontWeight: 'normal'
							}}>Drag your tools to arrange them in the order of intended use.</p>
							<br />
							<p tabIndex={0} className='title-font' style={{
								textAlign: 'center',
								margin: '0',
								fontSize: '14pt',
								fontWeight: 'normal'
							}} aria-label="For 5 O 8 users, please use enter to select a tool, then the tab key to cycle through the order areas, and then use the enter key again to assign the tool to the correct order step.">For 508 users, please use enter to select a tool, then the tab key to cycle through the order areas, and then use the enter key again to assign the tool to the correct order step.</p>
						</div>
						<div style={{
							position: 'absolute',
							top: '90px',
							left: '50%',
							width: '100%',
							transform: 'translate(-50%, 0)'
						}}>
							<img style={{
								position: 'absolute',
								top: '20px',
								left: '50%',
								transform: 'translate(-50%, 0)',
								width: '870px',
							}} src="./assets/images/Toolbag/Tools-bg.png" alt="" />
							<div style={{
								position: 'relative',
								left: '50%',
								transform: 'translate(-50%, 0)',
								width: '96%',
								height: '141px',
								top: '21px'
							}}>
								{props.parameters.toolsToChooseFrom.map((item: DraggedSingleData, indx: number) => {
									return spawnRowBttn(item.img, item.text, indx, true)
								})}
							</div>
							<div style={{
								position: 'relative',
								left: '50%',
								transform: 'translate(-50%, 0)',
								width: '96%',
								height: '191px',
								top: '30px'
							}}>
								{props.parameters.toolsToChooseFrom.map((item: DraggedSingleData, indx: number) => {
									return spawnRowBttn('', item.text, indx, false)
								})}
							</div>
						</div>
						{props.parameters.toolsToChooseFrom.length === 5 ? <div style={{
							position: 'absolute',
							bottom: '10px',
							width: '187px',
							height: '75px',
							left: '50%',
							transform: 'translate(-50%)'
						}}>
							<GeneralButtonWithText parameters={{
								text: '',
								ariaLbl: 'Done',
								id:"toolbag-done-button",
								top: '0',
								left: '0',
								width: '190px',
								srcIdle: "./assets/images/Toolbag/done_btn.jpg",
								srcHighlight: "./assets/images/Toolbag/done_btn.jpg",
								srcDisabled: "./assets/images/Toolbag/done_btn.jpg",
								isDisabled: draggedData.filter(dd => dd.img).length !== props.parameters.toolsToChooseFrom.length,
								customImgStyle: {
								},
								customButtonStyle: {
								},
								customTextStyle: {
									fontSize: '10pt'
								},
								onClicked: () => {
									props.parameters.onClose();

									if (props.parameters.onToolsArranged) {
										var text = [];
										for (var indx = 0; indx < draggedData.length; indx++) {
											text.push(draggedData[indx].text);
										}
										props.parameters.onToolsArranged(text, draggedData);
									}
								}
							}} />
						</div> : <div style={{
							position: 'absolute',
							bottom: '10px',
							width: '397px',
							height: '75px',
							left: '50%',
							transform: 'translate(-50%)'
						}}>
							<GeneralButtonWithText parameters={{
								text: '',
								id: isDoneDisabled() ? "toolbag-done-button" : "",
								ariaLbl: 'Cancel',
								top: '0',
								left: '0',
								width: '190px',
								srcIdle: "./assets/images/Toolbag/cancel_btn.jpg",
								srcHighlight: "./assets/images/Toolbag/cancel_btn.jpg",
								customImgStyle: {
								},
								customButtonStyle: {
								},
								customTextStyle: {
									fontSize: '10pt'
								},
								onClicked: () => {
									selectedIndx = -1;
									dataBeingDraggedNotInState = null;
									dataBeingDraggedNotInState508 = null;
									tempSelectedItem = -1;
									props.parameters.onClose();
								}
							}} />
							<GeneralButtonWithText parameters={{
								text: '',
								ariaLbl: 'Done',
								id:isDoneDisabled() ? "" : "toolbag-done-button",
								top: '0',
								left: '210px',
								width: '190px',
								srcIdle: "./assets/images/Toolbag/done_btn.jpg",
								srcHighlight: "./assets/images/Toolbag/done_btn.jpg",
								srcDisabled: "./assets/images/Toolbag/done_btn.jpg",
								isDisabled: isDoneDisabled(),
								customImgStyle: {
								},
								customButtonStyle: {
								},
								customTextStyle: {
									fontSize: '10pt'
								},
								onClicked: () => {
									props.parameters.onClose();

									if (props.parameters.onToolsArranged) {
										var text = [];
										for (var indx = 0; indx < draggedData.length; indx++) {
											text.push(draggedData[indx].text);
										}
										props.parameters.onToolsArranged(text, draggedData);
									}
								}
							}} />
						</div>}
					</div>
				</div>
			</div>
		</div>
	);
};

const CustomDragToolsButton = (props: CustomDragToolsButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			height: props.height,
			pointerEvents: 'none',
			outline: props.borderStyle
		}}>
			<div style={{
				position: 'relative',
				top: 0,
				left: '0',
				transform: ''
			}}>
				<GeneralButtonWithText parameters={{
					text: props.text,
					ariaLbl: props.ariaLbl,
					top: '0px',
					left: '0px',
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: props.idleImg,
					srcHighlight: null,
					srcDisabled: null,
					customMainStyle: {
						// position: 'relative',
						width: props.width,
						height: props.height,
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					customButtonStyle: {
						width: props.width,
						height: props.height,
					},
					customTextStyle: {
						color: 'rgb(0, 84, 178)',
						top: '16px',
						transform: 'translate(-50%, 0)',
						fontSize: '12pt',
						fontWeight: 'normal'
					},
					onKeyUp: (evt: any) => {
						if(props.onKeyUp) {
							props.onKeyUp(evt);
						}
					},
					onClicked: () => {
						// if (props.onClicked) {
						// 	props.onClicked();
						// }
					},
					onPressAndHold: () => {
						var method = (event: any) => {
							if (props.onDragEnd) {
								props.onDragEnd();
							}
							window.removeEventListener('pointerup', method);
							window.removeEventListener('mouseup', method);
						};
						window.addEventListener('pointerup', method);
						window.addEventListener('mouseup', method);

						if (props.onDragStart) {
							props.onDragStart();
						}
					},
					onMouseOut: () => {
						if (props.onMouseOut) {
							props.onMouseOut()
						}
					},
					onMouseOver: () => {
						if (props.onMouseOver) {
							props.onMouseOver()
						}
					}
				}} />
				<div style={{
					position: 'relative',
					top: props.top,
					width: props.width,
					// height: props.height,
					pointerEvents: 'none',
				}}>
					{props.foregroundImg ? <img style={{
						position: 'relative',
						top: '0',
						left: '50%',
						transform: 'translate(-50%, 0)',
						// width: props.width,
						// height: props.height,
					}} src={props.foregroundImg} /> : (null)}
				</div>

				{props.showReset ? <div style={{
					position: 'absolute',
					right: '12px',
					top: '9px',
					width: '27px',
					height: '27px',
					pointerEvents: 'all'
				}} tabIndex={0} role="button" aria-label="Reset Step" onKeyUp={mapDivEnterToClick} onClick={() => props.onReset()}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/Toolbag/reset.png" alt="" />
				</div> : (null)}
			</div>
		</div>
	);

};

interface CustomDragToolsButtonConfig {
	text: string;
	borderStyle: string;
	width: string;
	top: string;
	toolNumber: number;
	ariaLbl: string;
	height: string;
	onReset: () => void;
	showReset: boolean;
	position: CustomDragToolsButtonPosition;
	idleImg: string;
	foregroundImg: string;
	showYellowThingyOnTheSide?: boolean;
	isDraggable?: boolean;
	isDisabled?: boolean;
	onKeyUp?: (evt: any) => void;
	onDragStart?: () => void;
	onDragEnd?: () => void;
	onMouseOver?: () => void;
	onMouseOut?: () => void;
}

interface CustomDragToolsButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface DragToolsUIConfig extends BaseConfig {
	isTestScenario?: boolean;
	onIncorrectToolPicked?: () => void;
	toolsToChooseFrom: DraggedSingleData[];
	correctToolOrder?: DraggedSingleData[];
	onToolsArranged?: (text: string[], data: DraggedSingleData[]) => void;
	onClose?: () => void
}

export default DragToolsUI;